// extracted by mini-css-extract-plugin
export default {"item-not-found-container":"ItemNotFoundContainer_item-not-found-container__n5x6a"};